import "./Breadcrumbs.scss";
import React from "react";

export interface BreadcrumbsProps {
  children: JSX.Element[];
}

export default function Breadcrumbs({ children }: BreadcrumbsProps) {
  return <ul className={"breadcrumbs"}>{children}</ul>;
}
